import * as React from 'react';
import { useIsTestEnvironment } from '../../hooks/is-test-environment';

const prodSettings = {
    cssCtaUrl: 'https://sharefile.my.site.com/ESWShareFileMessaging1759486566575/sfsites/c/resource/NF_MessagingAssets/css/nfMessagingChatButton.css',
    language: "en_US",
    orgId: "00DDn00000AvI1G",
    esName: "ShareFile_Messaging",
    esUrl: "https://sharefile.my.site.com/ESWShareFileMessaging1759486566575",
    esScrt2Url: "https://sharefile.my.salesforce-scrt.com",
    bootstrapUrl: "https://sharefile.my.site.com/ESWShareFileMessaging1759486566575/assets/js/bootstrap.min.js"
};

const testSettings = {
    cssCtaUrl: 'https://sharefile--fulluat.sandbox.my.site.com/ESWShareFileMessaging1757593156813/sfsites/c/resource/NF_MessagingAssets/css/nfMessagingChatButton.css',
    language: "en_US",
    orgId: "00Dbb000003LjTR",
    esName: "ShareFile_Messaging",
    esUrl: "https://sharefile--fulluat.sandbox.my.site.com/ESWShareFileMessaging1757593156813",
    esScrt2Url: "https://sharefile--fulluat.sandbox.my.salesforce-scrt.com",
    bootstrapUrl: "https://sharefile--fulluat.sandbox.my.site.com/ESWShareFileMessaging1757593156813/assets/js/bootstrap.min.js"
};

const prodUrl = `https://sharefile.my.site.com/ESWShareFileMessaging1759486566575/sfsites/c/resource/NF_MessagingAssets/js/nfEsBootstrap-exp.js`;
const testUrl = `https://sharefile--fulluat.sandbox.my.site.com/ESWShareFileMessaging1757593156813/sfsites/c/resource/NF_MessagingAssets/js/nfEsBootstrap.js`;

const AgentForceChat = () => {
    const isTest = useIsTestEnvironment();

    React.useEffect(() => {
        window.nfEmbedSettings = isTest ? testSettings : prodSettings;

        const script = document.createElement('script');
        script.src = isTest ? testUrl : prodUrl;
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [isTest]);

    return null;
}

export default AgentForceChat;